import React, { useContext, useEffect, useState } from "react";
import { Box, Typography, Grid, Button, Chip, TextField, CircularProgress, IconButton } from "@mui/material";
import { CategoryFrecuents } from "../CategoryFrecuents";
import { SnackSimple } from "../../../../../../../../components";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";
import { icons } from "../../../../../../../../utils/icons";
import { ObjectGeneric, onChangeEvent } from "../../../../../../../../utils/types/generals";
import { CategoryInterface, FormContext, IdSubOptionInterface, SelectedSubcategoryInterface, SubcategoryInterface } from "../../Context";
import { useGetData } from "../../hooks/useGetData";
import MultiSelectSimple from "../../../../../../../../components/dinamicForm/multiSelectSimple";
import { EvidenceStateValue, UserInfo } from "../../Interfaces";
import { Types } from "../../../../../../../../utils/enums";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import dayjs from "dayjs";
import { Constants } from "../../../../../../../../utils/constants";
import Loader from "../../../../../../../../components/loader";
import { FolioTypeEndPoint } from "../../../../utils/enums/endpointFolioType";
import { FolioType } from "../../../../utils/enums/folioType";
import { EvidencesTypeValueEnum } from "../../../../../../../../utils/enums/evidences";

export const Step1 = ({ onContinue }: { onContinue: () => void }) => {
  const { t } = useTranslation()
  const navigate = useNavigate();
  const { areas, departments, loadDepartmentsByArea, getCategoriesByDepartment, getConfig, config, getCorrectiveData, options, isOptionsLoaded, notOptions, fetchFrequentOptions } = useGetData();
  const { formData, updateFormData, id, isEdit, setIsEdit, configCopy, setConfigCopy } = useContext(FormContext);
  const [selectedCategory, setSelectedCategory] = useState(formData.selectedCategory || null);
  const [selectedSubcategories, setSelectedSubcategories] = useState<SelectedSubcategoryInterface[]>(
    formData.selectedSubcategories?.length ? formData.selectedSubcategories : []
  );
  const [subcategoryText, setSubcategoryText] = useState(formData.subcategoryText || "");
  const [selectedArea, setSelectedArea] = useState<ObjectGeneric | null | undefined>(formData.idSubOption ? null : formData.area);
  const [selectedDepartment, setSelectedDepartment] = useState<ObjectGeneric | null | undefined>(formData.idSubOption ? null : formData.department);
  const [categories, setCategories] = useState<CategoryInterface[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingCategories, setIsLoadingCategories] = useState(false);
  const [showConfigWarning, setShowConfigWarning] = useState(false);
  const [hasValidConfig, setHasValidConfig] = useState(true);
  const styles = useStyles();
  const [subCategoryIsSelected, setSubcategoryIsSelected] = useState<SubcategoryInterface | null>(null)
  const [flag, setFlaf] = useState(formData.flag ?? true)
  const [idSubOption, setIdSubOption] = useState<IdSubOptionInterface | undefined>(formData.idSubOption)

  /* useEffect(() => {
    checkConfig();
  }, [formData.area, formData.department]); */

  const checkConfig = async (dataDepartment: ObjectGeneric | null | undefined, area: ObjectGeneric | null | undefined, flag: boolean | undefined) => {
    if (area && dataDepartment) {
      const config = await getConfig(area.id, dataDepartment.value);
      if (!config || (Array.isArray(config) && config.length === 0)) {
        setHasValidConfig(false);
        setShowConfigWarning(true);
        return false;
      }
      if (!!flag) {
        setConfigCopy(
          config.configActionPlanReportFolioEvidenceTypes.filter(
            (item) => item.type === 'CREATE'
          )
        );
        /* setConfigCopy(config.configActionPlanReportFolioEvidenceTypes) */
      }
      //const configExists = config.configActionPlanReportFolioEvidenceTypes && config.configActionPlanReportFolioEvidenceTypes.length > 0;
      const configExists = config.configActionPlanReportFolioEvidenceTypes?.some(
        (item) => item.type === 'CREATE'
      );
      setHasValidConfig(configExists);
      setShowConfigWarning(!configExists);
      return configExists;
    }

    setHasValidConfig(true);
    return true;
  };

  useEffect(() => {

    if (config?.configActionPlanReportFolioEvidenceTypes?.some((item) => item.type === 'CREATE')) {

      const evidenceConfig: { [key: number]: EvidenceStateValue } = {};

      const groupedEvidences = formData.evidencesDataEdit?.reduce((acc: any, item: any) => {
        if (item.evidenceTypeId !== undefined) {
          if (!acc[item.evidenceTypeId]) {
            acc[item.evidenceTypeId] = {};
          }
          acc[item.evidenceTypeId][item.originalname] = { name: item.originalname, progress: false, progressAmount: undefined, upload: false, url: item.url }; // Se usa originalname como clave
        } else if (item.comments && Array.isArray(item.comments)) {
          const commentKey = EvidencesTypeValueEnum.COMMENT;
          if (!acc[commentKey]) {
            acc[commentKey] = {};
          }
          item.comments.forEach((comment: string, index: number) => {
            acc[commentKey][comment] = {
              name: comment,
              url: comment
            };
          });
        }
        return acc;
      }, {});

      const mergeConfigurations = (config1: any, config2: any) => {
        const uniqueMap = new Map();

        config1.forEach((item: any) => {
          uniqueMap.set(item.evidenceType.id, { ...item, required: false });
        });

        config2.forEach((item: any) => {
          uniqueMap.set(item.evidenceType.id, item);
        });

        return Array.from(uniqueMap.values());
      }

      const newConfig = !id ? config.configActionPlanReportFolioEvidenceTypes.filter((item) => item.type === 'CREATE') : mergeConfigurations(configCopy, config.configActionPlanReportFolioEvidenceTypes.filter((item) => item.type === 'CREATE'))
      newConfig.forEach((type: any) => {
        const evidenceType = type.evidenceType;
        const params = type.paramsConfiguration;
        const required = type.required

        evidenceConfig[parseInt(evidenceType.id)] = {
          expanded: false,
          seeFiles: true,
          required: required,
          customeTitle: evidenceType.description || evidenceType.key,
          maxCount: params?.amounts || 10,
          minAmount: type.required ? (params?.min || 1) : 0,
          size: params?.sizes || 5,
          value: !id ? {} : groupedEvidences[evidenceType.id] || {},
          accept: params?.types
            ? params.types.map((t: string) => `.${t}`).join(',')
            : Constants.acceptFile[type.evidenceTypeId.toString()]?.map((t: string) => `.${t}`).join(',')
        };
      });
      updateFormData({
        ...formData,
        evidences: formData.evidences ? formData.evidences : {
          value: evidenceConfig,
          open: false,
          type: {
            equivalence: [],
            accept: '',
          },
        }
      });

    }
  }, [config]);

  useEffect(() => {
    const loadInitialData = async () => {
      if (selectedArea) {
        try {
          await loadDepartmentsByArea(selectedArea);
          if (selectedDepartment) {
            setIsLoadingCategories(true);
            const fetchedCategories = await getCategoriesByDepartment(selectedDepartment.value, FolioTypeEndPoint.PREVENTIVE);
            setCategories(fetchedCategories);
          }
        } catch (error) {
          console.error('Error loading initial data:', error);
        } finally {
          setIsLoading(false);
          setIsLoadingCategories(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    loadInitialData();
  }, [selectedArea, selectedDepartment]);

  useEffect(() => {
    if (!id) {
      fetchFrequentOptions();
    }
  }, []);


  const setDateFolio = async () => {
    if (id) {
      const data = await getCorrectiveData(id)
      const groupedData = data?.categories?.reduce((acc, item) => {
        const { categoryId, category, subcategoryId, subcategory, requestText, userAssignId } = item;

        // Buscar si la categoría ya existe
        let categoryItem = acc.find(cat => cat.id === categoryId);

        if (!categoryItem) {
          // Si no existe, crearla
          categoryItem = {
            name: category,
            id: categoryId,
            subcategories: []
          };
          acc.push(categoryItem);
        }

        // Agregar la subcategoría
        categoryItem.subcategories.push({
          categoryId,
          id: subcategoryId,
          name: subcategory,
          requestText,
          supllierId: item.userAssignId, // Cambio de nombre a supllierId
          priority: data?.priority,
          priorityId: data?.priority?.id,
          user: {
            id: userAssignId,
            label: `Usuario ${userAssignId}` // Puedes reemplazarlo con nombre real si está disponible
          }
        });

        return acc;
      }, [] as { name: string, id: number, subcategories: any[] }[]);
      updateFormData({
        area: {
          value: String(data?.area?.id),
          label: data?.area?.name,
          id: data?.area?.id
        },
        department: {
          value: String(data?.department?.id),
          label: data?.department?.name
        },
        //categoryIdSelected: data?.categories ? data?.categories[0].categoryId : undefined,
        //selectedCategory: data?.categories ? data.categories[0].category : '',
        categoriesCopy: groupedData,
        selectedSubcategories: data?.categories ?
          data.categories.map(category => ({
            categoryName: category.category,
            id: category.subcategoryId,
            name: category.subcategory,
            requestText: category.requestText,
            priority: data.priority,
            priorityId: data.priority?.id,
            textRequest: category.subcategoryText,
            user: {
              label: data?.reportFolioUserAssign?.length
                ? `${data?.reportFolioUserAssign[0].firstName} ${data?.reportFolioUserAssign[0].lastName}`
                : '',
              id: data?.reportFolioUserAssign ? data?.reportFolioUserAssign[0].id : 0,
            }
          }))
          : [],
        selectedSubcategoriesCopy: data?.categories ?
          data.categories.map(category => ({
            categoryName: category.category,
            id: category.subcategoryId,
            name: category.subcategory,
            requestText: category.requestText,
            priority: data.priority,
            priorityId: data.priority?.id,
            textRequest: category.subcategoryText,
            user: data?.reportFolioUserAssign?.length ? {
              label: data?.reportFolioUserAssign?.length
                ? `${data?.reportFolioUserAssign[0].firstName} ${data?.reportFolioUserAssign[0].lastName}`
                : '',
              id: data?.reportFolioUserAssign ? data?.reportFolioUserAssign[0].id : 0,
            } : null
          }))
          : [],
        selectedUnit: {
          value: String(data?.store?.id),
          label: data?.store?.name,
          extraData: {
            timeZone: {
              code: data?.store?.storeTimeZone.code,
              value: data?.store?.storeTimeZone.value,
              zone: data?.store?.storeTimeZone.zone
            }
          }
        },
        selectedPriority: { value: String(data?.priority?.id), label: data?.priority?.name },
        startDate: dayjs(data?.dateStart).tz(data?.store?.storeTimeZone.code).locale('es'),  //dayjs.utc(response.dateStart).format(Constants.dayjsFormat3)
        endDate: dayjs(data?.dateEnd).tz(data?.store?.storeTimeZone.code).locale('es'),
        //selectedFrecuency:,
        //selectedEvery:,
        executionDate: dayjs(data?.dateStartQuestionnaire).tz(data?.store?.storeTimeZone.code).locale('es'),
        executionEndDate: dayjs(data?.dateEndQuestionnaire).tz(data?.store?.storeTimeZone.code).locale('es'),
        selestedQuestionnarie: { value: String(data?.questionnaireId) },
        notifyAssignment: data?.notified,
        selectedTime: { value: String(data?.timeNotification) },
        selectedProvider: data?.reportFolioUserAssign?.length ? {
          value: String(data?.reportFolioUserAssign?.length ? data?.reportFolioUserAssign[0].id : ''),
          label: data?.reportFolioUserAssign?.length ? `${data?.reportFolioUserAssign[0].firstName} ${data?.reportFolioUserAssign[0].lastName}` : ''
        } : null,
        selectedProviderCopy: data?.reportFolioUserAssign?.length ? {
          value: String(data?.reportFolioUserAssign?.length ? data?.reportFolioUserAssign[0].id : ''),
          label: data?.reportFolioUserAssign?.length ? `${data?.reportFolioUserAssign[0].firstName} ${data?.reportFolioUserAssign[0].lastName}` : ''
        } : null,
        title: data?.name,
        description: data?.description,
        //subcategoryText: data?.categories ? data?.categories[0].subcategoryText : undefined,
        evidencesDataEdit: data?.evidences,
        flag: true
      });
      setSelectedArea({
        value: String(data?.area?.id),
        label: data?.area?.name,
        id: data?.area?.id
      })
      setSelectedDepartment({
        value: String(data?.department?.id),
        label: data?.department?.name
      })
      //setSelectedCategory(data?.categories ? data.categories[0].category : '')
      setSelectedSubcategories(data?.categories ?
        data.categories.map(category => ({
          categoryName: category.category,
          id: category.subcategoryId,
          name: category.subcategory,
          requestText: category.requestText,
          priority: data.priority,
          priorityId: data.priority?.id,
          textRequest: category.subcategoryText,
          user: {
            label: data?.reportFolioUserAssign?.length
              ? `${data?.reportFolioUserAssign[0].firstName} ${data?.reportFolioUserAssign[0].lastName}`
              : '',
            id: data?.reportFolioUserAssign ? data?.reportFolioUserAssign[0].id : 0,
          }
        })) : [])
      //setSubcategoryText(data?.categories ? String(data?.categories[0].subcategoryText) : '')
      checkConfig({ value: String(data?.department?.id), label: data?.department?.name }, { value: String(data?.area?.id), label: data?.area?.name, id: data?.area?.id }, true)
    }
  }

  useEffect(() => {
    if (!isEdit && !!id) {
      setDateFolio()
      setIsEdit(true)
    }
  }, [id]);

  const handleCategoryClick = (category: { name: string, id: number }) => {
    if (category == selectedCategory) {
      return
    }
    setSelectedCategory(category);
    setSubcategoryIsSelected(null)
    setSubcategoryText("");
    updateFormData({
      subcategoryText: ""
    });
  };

  const handleAreaChange = async (e: onChangeEvent) => {
    const areaId = e.target.value;
    if (idSubOption) {
      setSelectedSubcategories([]);
      setSelectedCategory(null);
      setSubcategoryText("");
      updateFormData({
        selectedCategory: undefined,
        selectedSubcategories: [],
        subcategoryText: "",
        idSubOption: undefined
      });
    }
    setIdSubOption(undefined)
    if (!areaId) {
      setSelectedArea(null);
      setSelectedDepartment(null);
      setCategories([]);
      setSelectedCategory(null);
      setSubcategoryIsSelected(null)
      setSelectedSubcategories(formData?.selectedSubcategoriesCopy ?? []);
      setSubcategoryText("");
      updateFormData({
        area: null,
        department: null,
        selectedCategory: undefined,
        selectedSubcategories: formData.selectedSubcategoriesCopy ?? [],
        subcategoryText: "",
        evidences: undefined,
        idSubOption: undefined
      });
      return;
    }

    setSelectedArea(areaId);
    setSelectedDepartment(null);
    setCategories([]);
    setSelectedCategory(null);
    setSubcategoryIsSelected(null)
    setSelectedSubcategories(formData?.selectedSubcategoriesCopy ?? []);
    setSubcategoryText("");
    await loadDepartmentsByArea(areaId);
    updateFormData({
      area: areaId,
      department: null,
      selectedCategory: undefined,
      selectedSubcategories: formData.selectedSubcategoriesCopy ?? [],
      subcategoryText: "",
      evidences: undefined,
      idSubOption: undefined
    });
  };

  const handleDepartmentChange = async (e: onChangeEvent) => {
    const departmentId = e.target.value;
    if (idSubOption) {
      setSelectedSubcategories([]);
      setSelectedCategory(null);
      setSubcategoryText("");
      updateFormData({
        selectedCategory: undefined,
        selectedSubcategories: [],
        subcategoryText: "",
        idSubOption: undefined
      });
    }
    setIdSubOption(undefined)
    if (!departmentId) {
      setCategories([])
      setSelectedDepartment(null);
      setSelectedCategory(null);
      setSubcategoryIsSelected(null)
      setSelectedSubcategories(formData?.selectedSubcategoriesCopy ?? []);
      setSubcategoryText("");
      updateFormData({
        department: null,
        selectedCategory: undefined,
        selectedSubcategories: formData.selectedSubcategoriesCopy ?? [],
        subcategoryText: "",
        evidences: undefined,
        idSubOption: undefined
      });
      return;
    }

    setSelectedDepartment(departmentId);
    setSelectedCategory(null);
    setSubcategoryIsSelected(null)
    setSelectedSubcategories(formData?.selectedSubcategoriesCopy ?? []);
    setSubcategoryText("");

    const fetchedCategories = await getCategoriesByDepartment(departmentId.value, FolioTypeEndPoint.PREVENTIVE);
    setCategories(fetchedCategories);

    updateFormData({
      department: departmentId,
      selectedCategory: undefined,
      selectedSubcategories: formData.selectedSubcategoriesCopy ?? [],
      subcategoryText: "",
      evidences: undefined,
      idSubOption: undefined
    });
    checkConfig(departmentId, formData.area, false);
  };

  const handleSubcategorySelect = (subcategory: SubcategoryInterface) => {

    if (!selectedCategory) {
      console.warn('No category selected');
      return;
    }

    const isCurrentlySelected = subCategoryIsSelected?.id === subcategory.id;

    if (isCurrentlySelected) {
      setSubcategoryIsSelected(null)
    } else {
      setSubcategoryIsSelected(subcategory)
    }
  };

  const handleAddSubcategory = () => {

    if (!selectedCategory || !subCategoryIsSelected) {
      console.warn('No category selected');
      return;
    }

    let userInfo: UserInfo | null = null;

    if (subCategoryIsSelected.user) {
      userInfo = {
        label: `${subCategoryIsSelected.user.firstName} ${subCategoryIsSelected.user.lastName}`,
        id: subCategoryIsSelected.user.id,
        value: subCategoryIsSelected.user.id
      };
    }

    const newSubcategory: SelectedSubcategoryInterface = {
      id: subCategoryIsSelected.id,
      name: subCategoryIsSelected.name,
      categoryName: selectedCategory.name,
      user: userInfo,
      requestText: subCategoryIsSelected.requestText,
      textRequest: subcategoryText
    };

    setSelectedSubcategories((prev) => [...prev, newSubcategory]);
    setSubcategoryText("");
    updateFormData({
      selectedSubcategories: formData.selectedSubcategories ? [...formData.selectedSubcategories, newSubcategory] : [newSubcategory],
      subcategoryText: ""
    });

    setSubcategoryIsSelected(null)
    setSelectedCategory(null)


  };

  const handleSubcategoryTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newText = event.target.value;
    setSubcategoryText(newText);
    updateFormData({ subcategoryText: newText });
  };

  const searchCategories = async () => {
    const fetchedCategories = await getCategoriesByDepartment(formData.department?.value, FolioTypeEndPoint.PREVENTIVE);
    setCategories(fetchedCategories);
    updateFormData({
      categories: fetchedCategories
    });
  }

  useEffect(() => {
    if (idSubOption) {
      searchCategories()
    }
  }, [idSubOption])

  const handleOptionSelected = (areaId: number, areaName: string, departmentId: number, departmentName: string, subcategories: { id: number, name: string, categoryName: string }[], userAssigned?: number) => {

    setSelectedArea(null);
    setSelectedDepartment(null);
    setCategories([]);

    const subcategoriesFormatted = subcategories?.map(sub => ({
      subcategoryId: sub.id,
      subcategory: sub.name,
      category: sub.categoryName
    }));

    setIdSubOption({ areaId, departmentId, subcategories: subcategoriesFormatted, userAssigned })

    setSelectedSubcategories(subcategories);

    updateFormData({
      idSubOption: { areaId, departmentId, subcategories: subcategoriesFormatted, userAssigned },
      area: { value: String(areaId), label: areaName, id: areaId },
      department: { value: String(departmentId), label: departmentName, id: departmentId },
      selectedCategory: undefined,
      selectedSubcategories: subcategories,
      subcategoryText: "",
      evidences: undefined
    });


    checkConfig({ value: String(departmentId), label: departmentName, id: departmentId }, { value: String(areaId), label: areaName, id: areaId }, false);
  }

  /* useEffect(()=>{
    console.log("cambio")
    if(idSubOption){
      console.log({idSubOption})
      const subCategory = categories
                    .find((cat) => cat.name === selectedCategory)
                    ?.subcategories.find((sub: any, idx: number) => sub.id === idSubOption)
                    console.log({subCategory})
      if(subCategory){
        handleSubcategorySelect(subCategory)
      }
    }
  },[categories]) */

  const handleRemoveSelection = (id: number) => {
    setSelectedSubcategories((prev) => prev.filter(sub => sub.id !== id));
    setSubcategoryText("");
    setIdSubOption(undefined)
    updateFormData({
      selectedSubcategories: formData.selectedSubcategories ? formData.selectedSubcategories?.filter(sub => sub.id !== id) : [],
      selectedSubcategoriesCopy: formData.selectedSubcategoriesCopy ? formData.selectedSubcategoriesCopy?.filter(sub => sub.id !== id) : [],
      subcategoryText: "",
      idSubOption: undefined
    });
  };

  const handleRegresar = () => {
    navigate("/dashboard/report-folio/dashboard");
  };

  const commonButtonStyles = (isSelected: boolean) => ({
    textTransform: "none",
    borderBottom: isSelected ? "none" : "2px solid #ddd",
    borderRadius: 0,
    backgroundColor: isSelected ? "#1976d2" : "transparent",
    color: isSelected ? "#fff" : "#000",
    "&:hover": {
      backgroundColor: isSelected ? "#1565c0" : "#f0f0f0",
      borderBottom: "2px solid #1976d2",
    },
    padding: "8px 16px",
  });

  const handleContinue = () => {
    if (!idSubOption) {
      if (selectedSubcategories.length === 0) return;

      updateFormData({
        selectedCategory,
        selectedSubcategories,
        area: selectedArea,
        department: selectedDepartment,
        categories,
        subcategoryText
      });

      onContinue();
    } else {
      if (selectedSubcategories.length === 0) return;
      onContinue();
    }
  };

  const shouldShowTextField = subCategoryIsSelected?.requestText;

  if (isLoading) {
    return (<CircularProgress />);
  }

  return (
    <Box mt={2}>

      {isOptionsLoaded ?
        <Loader />
        :
        <>
          {!notOptions && !id ?
            <>
              <Box mb={2}>
                <Typography variant="body1" fontWeight="bold">
                  {t("reportFolio.forms.MostFrecuenceSelection")}
                </Typography>
              </Box>
              <Grid container spacing={2}>
                {options.map((option, index) => (
                  <Grid
                    item
                    xl={3}
                    xs={6}
                    sm={6}
                    md={6}// 3 columnas en pantallas grandes (4 elementos en una fila)
                    key={index}
                    sx={{ display: 'flex' }}
                  >
                    <CategoryFrecuents {...option} onClickPreventive={handleOptionSelected} typeFolio={FolioType.PREVENTIVE} idSubOptionPreventive={idSubOption} />
                  </Grid>
                ))}
              </Grid>
            </>
            :
            <></>
          }
        </>
      }


      <Grid container spacing={4} mt={4}>
        {/* Zona de gestion */}
        <Grid item xs={6} sm={6} xl={3.2} sx={styles.gestionZoneGrid}>
          <Box sx={styles.gestioneZoneBox}>
            <Typography variant="body1" fontWeight={"bold"}>{t("reportFolio.forms.gestionZone")}</Typography>
            <MultiSelectSimple
              isRequired
              name="Area"
              label={"Área *"}
              onChange={handleAreaChange}
              items={areas}
              selected={selectedArea}
            />
            <MultiSelectSimple
              isRequired
              name="Departamento"
              label={"Departamento *"}
              onChange={handleDepartmentChange}
              items={departments}
              selected={selectedDepartment}
              disabled={!selectedArea}
            />
          </Box>

        </Grid>

        {/* Seleccionar categorías y subcategorías */}
        <Grid item xs={6} sm={6} xl={4.8} sx={styles.categoryAndSubCategoryGrid}>
          <Typography variant="body1" fontWeight="bold" mb={1}>
            {t("reportFolio.forms.selectCategories")}
          </Typography>

          <Box display="flex" flexDirection="column" gap={2}>
            <Box display="flex" alignItems="flex-start" gap={2}>
              <Box display="flex" flexDirection="column" gap={1} sx={{ minWidth: "30%" }}>
                {isLoadingCategories ? (
                  <CircularProgress />
                ) : (categories.length === 0 && selectedDepartment ? (
                  <Box sx={{ textAlign: "center", color: "#999", fontStyle: "italic", padding: "8px" }}>
                    {t('reportFolio.detail.general.departmentWithoutCategories')}
                  </Box>
                ) : (
                  !idSubOption && categories.map((category, index) => (
                    <Button
                      key={index}
                      onClick={() => handleCategoryClick({ name: category.name, id: category.id })}
                      sx={{
                        ...commonButtonStyles(selectedCategory?.id === category.id)
                      }}
                    >
                      {category.name}
                    </Button>
                  ))
                ))}
              </Box>

              <Box display="flex" flexDirection="column" gap={1} sx={{ minWidth: "30%" }}>
                {!idSubOption && selectedCategory && !isLoadingCategories && (
                  categories
                    .find((cat) => cat.id === selectedCategory.id)
                    ?.subcategories.map((sub: any, idx: number) => {
                      const isSelected = subCategoryIsSelected?.id === sub.id;
                      const isDisabled = selectedSubcategories.some(subCa => subCa.id === sub.id)
                      return (
                        <Button
                          key={idx}
                          onClick={() => handleSubcategorySelect(sub)}
                          disabled={isDisabled}
                          sx={{
                            ...commonButtonStyles(isSelected)
                          }}
                        >
                          {sub.name}
                        </Button>
                      );
                    })
                )}
              </Box>
            </Box>

            {!!subCategoryIsSelected && !isLoadingCategories &&
              <Box sx={styles.containerTextAndButton}>
                {shouldShowTextField && (
                  <Box sx={{ width: "100%" }}>
                    <TextField
                      fullWidth
                      label="Detalle*"
                      variant="outlined"
                      value={subcategoryText}
                      onChange={handleSubcategoryTextChange}
                      multiline
                      rows={2}
                      sx={{
                        /* width: {
                          md: '94%',
                          xl: 'calc(77% - 16px)'
                        }, */
                        marginLeft: "0px"
                      }}
                    />
                  </Box>
                )}
                <IconButton sx={styles.buttonAdd(!!shouldShowTextField && !subcategoryText)} disabled={shouldShowTextField && !subcategoryText} onClick={handleAddSubcategory}>
                  <AddIcon />
                </IconButton>
              </Box>
            }
          </Box>

        </Grid>

        <Grid item xs={12} sm={6} xl={4} >
          <Typography variant="body1" fontWeight="bold" mb={1}>
            {t("reportFolio.forms.categoriesSelected")}
          </Typography>
          <Box sx={styles.categoriesSelected}>
            {idSubOption || !selectedSubcategories.length ?
              (
                <Box sx={styles.containerNoCategories}>
                  {icons('info-outlined')}
                  <Typography>{t("reportFolio.forms.noCategoriesSelected")}</Typography>
                </Box>
              )
              :
              (
                <>
                  {selectedSubcategories.map((sub) => (
                    <Chip
                      key={sub.id}
                      label={`${sub.categoryName} - ${sub.name}`}
                      onDelete={() => handleRemoveSelection(sub.id)}
                      sx={{ margin: 0.5 }}
                    />
                  ))}
                </>
              )
            }
          </Box>
        </Grid>
      </Grid>
      {/* Formulario */}

      <Box sx={styles.btnsContainer}>
        <Button onClick={handleRegresar} sx={styles.btnBack}>
          {t("reportFolio.forms.back")}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleContinue}
          sx={{borderRadius:'4px'}}
          disabled={
            !idSubOption &&
            (
              !selectedArea ||
              !selectedDepartment ||
              !categories.length ||
              selectedSubcategories.length === 0 ||
              !hasValidConfig
            )
          }
        >
          {t("reportFolio.forms.continue")}
        </Button>
      </Box>

      <SnackSimple
        open={showConfigWarning}
        close={() => setShowConfigWarning(false)}
        message="Para crear un folio en esta área y departamento, debes crear una configuración."
        type={Types.INFO}
      />


    </Box>
  );
};